import useLandingConstructorStore from 'pages/landing/landingConstructor/zustand/store'

export function useGetColorScheme() {
	return useLandingConstructorStore((store) => store.landing!.colorScheme)
}
